<template>
  <v-card style="background-color: rgba(0,0,0,0); max-height: 30vh !important;" class="overflow-y-auto px-3 py-2" outlined>
    <v-container class="pa-5" fluid>
      <v-row align="center" justify="center">
        <h2>{{ $t('title') }}</h2>
      </v-row>
      <v-row align="center" justify="start">
        <v-list class="mb-n2" style="background-color: rgba(0,0,0,0)">
          <v-list-item class="mb-n1" v-for="(award, i) in $store.state.tournament.awards" v-bind:key="i" dense>
            <v-chip color="secondary" small>
              {{ i + 1 }}° {{ $t('wins') }} {{ award.description }}
              <v-icon color="green accent-3" class="ml-2" small>fa-medal</v-icon>
            </v-chip>
          </v-list-item>
        </v-list>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "TournamentAwards",
  props: {
    awards: Array,
  },
  methods: {

  }
}
</script>

<i18n>
{
  "en": {
    "title": "Tournament Awards",
    "wins": "wins"
  },
  "es": {
    "title": "Premios del Torneo",
    "wins": "gana"
  }
}
</i18n>

<style scoped>

</style>
